import type { FaireBrandEntity } from "../../entity_types/brand";

export const chunks: FaireBrandEntity = {
  token: "chunks",
  type: "brand",
  name: "Chunks",
  logoUrl:
    "https://cdn.shopify.com/s/files/1/0510/2698/5143/files/CheckerClawBlackWhiteSilo.jpg?v=1732069516",
  minimumOrderDollars: 130,
  rating: 4.8,
  location: "Los Angeles, CA",
  tags: ["hair accessories", "claws", "barrettes", "clips"],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
